import type { BlockDef } from '../../prop-types.ts'
import { EMPTY_TEXT } from '../../text.ts'

/**
 * What customers said.
 *
 * ⚠️ THE ONE BLOCK WHOSE AI GENERATION IS DELIBERATELY CRIPPLED, and the reason is in
 * `whenNotToUse` where the model will read it. Every other block can be drafted from a business
 * description and corrected; a fabricated review is a false statement about a named third party,
 * published under a real business's name. The generator seeds this block **empty with a prompt**,
 * never with invented quotes. See `ai-schema.ts`, which drops it from the tool set entirely.
 */
export const testimonials: BlockDef = {
  type: 'testimonials',
  v: 1,
  label: { en: 'Testimonials', ar: 'آراء العملاء' },
  scope: 'page',
  description: 'Short quotes from real customers, each with the name of the person who said it.',
  whenToUse: 'When the business HAS reviews and the owner has pasted them in.',
  whenNotToUse:
    'NEVER invent these. A made-up quote attributed to a made-up person, published on a real business’s site, is a fabricated endorsement. Leave the block empty for the owner to fill in.',
  variants: [
    { value: 'cards', label: { en: 'Cards', ar: 'بطاقات' } },
    { value: 'quote', label: { en: 'One large quote', ar: 'اقتباس واحد كبير' } },
  ],
  fields: [
    { key: 'heading', label: { en: 'Heading', ar: 'العنوان' }, type: { kind: 'text' }, default: EMPTY_TEXT },
    {
      key: 'items',
      label: { en: 'Quotes', ar: 'الاقتباسات' },
      type: {
        kind: 'list',
        max: 12,
        item: [
          { key: 'quote', label: { en: 'What they said', ar: 'ما قالوه' }, type: { kind: 'longText' }, default: EMPTY_TEXT },
          { key: 'name', label: { en: 'Who said it', ar: 'من قاله' }, type: { kind: 'text' }, default: EMPTY_TEXT },
          {
            key: 'rating',
            label: { en: 'Stars', ar: 'النجوم' },
            type: { kind: 'number', min: 1, max: 5 },
            default: 5,
          },
        ],
      },
      default: [],
    },
  ],
}
